'use client';
import Image, { ImageProps } from 'next/image';
import { useState } from 'react';
import { CarPlaceholderGif } from '../../../public/Images';

export enum EImageCarLoading {
    eager = 'eager',
    lazy = 'lazy',
}

export type TImageCar = {
    style: any;
    objectFitValue: 'contain' | 'cover';
    limitPlaceHolderHeight: boolean;
    disablePlaceHolder?: boolean;
    loadingMethod?: 'eager' | 'lazy';
    priority?: boolean;
} & ImageProps;
const ImageCar = ({
    src,
    style,
    alt,
    width = 306,
    height = 230,
    quality = 90,
    limitPlaceHolderHeight = false,
    objectFitValue,
    disablePlaceHolder,
    loadingMethod = EImageCarLoading.eager,
    priority = false,
}: TImageCar) => {
    const [loaded, setLoaded] = useState<boolean>(false);

    return (
        <>
            <Image
                width={width}
                height={height}
                quality={quality}
                src={
                    // src
                    priority || loaded || disablePlaceHolder
                        ? src
                        : CarPlaceholderGif
                }
                alt={alt || 'Car image'}
                style={{
                    ...style,
                    objectFit: objectFitValue,
                    maxHeight: limitPlaceHolderHeight ? height : 'none',
                }}
                onLoad={() => {
                    // if (priority) return;
                    setLoaded(true);
                }}
                loading={loadingMethod}
                priority={priority}
            />
        </>
    );
};

export default ImageCar;
